import { render, staticRenderFns } from "./feature-icon.vue?vue&type=template&id=991b54aa&scoped=true&"
import script from "./feature-icon.vue?vue&type=script&lang=js&"
export * from "./feature-icon.vue?vue&type=script&lang=js&"
import style0 from "./feature-icon.vue?vue&type=style&index=0&id=991b54aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991b54aa",
  null
  
)

export default component.exports